// extracted by mini-css-extract-plugin
var _1 = "Drawvas__eraser--iRa96";
var _2 = "Drawvas__inner--tU1OJ";
var _3 = "Drawvas__main--hZV10";
var _4 = "Drawvas__pencil--gWT6O";
export { _1 as "eraser", _2 as "inner", _3 as "main", _4 as "pencil" }
